$(document).ready(function () {
    //$('.dbh_popupInnerContainer').draggable({ handle: ".draggable", cursor: "move" });

    if (typeof (window as any).showPopup != 'function') {
        (window as any).showPopup = function showPopup(id) {
            $('#' + id).fadeIn("fast");
            //$('.dbh_popupInnerContainer').draggable({ handle: ".draggable", cursor: "move" });
        };
    }

    if (typeof (window as any).hidePopup != 'function') {
        (window as any).hidePopup = function hidePopup(id) {
            $('#' + id).fadeOut("fast");
        };
    }
    
    if (typeof (window as any).hidePopups != 'function') {
        (window as any).hidePopups = function hidePopups(cssClass) {
            $('.' + cssClass).fadeOut("fast");
        };
    }

    $(document).keyup(function (e) {
        // Popup mit ESC ausblenden
        if (e.keyCode == 27) {
            (window as any).hidePopups('dbh_popup');
        }
    });
});
